var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u-clear" }, [
    _c("div", { staticClass: "title u-clear" }, [
      _c("p", { staticClass: "u-fl" }, [_vm._v("Image")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "u-fr",
          on: {
            click: function($event) {
              return _vm.remove()
            }
          }
        },
        [_c("icon-delete")],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "u-fr",
          class: { disabled: _vm.last },
          on: {
            click: function($event) {
              return _vm.backwards()
            }
          }
        },
        [_c("icon-down")],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "u-fr",
          class: { disabled: _vm.first },
          on: {
            click: function($event) {
              return _vm.forwards()
            }
          }
        },
        [_c("icon-up")],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field small" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Left")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.left },
          on: {
            change: function($event) {
              return _vm.prop("left", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field small" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Top")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.top },
          on: {
            change: function($event) {
              return _vm.prop("top", $event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field large" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Scale")]),
        _vm._v(" "),
        _c("ui-number", {
          attrs: { value: _vm.active.scaleX },
          on: {
            change: function($event) {
              return _vm.scale($event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }